// React Router
import { Route, Routes } from "react-router-dom";

// Types
import { PriceRouterCmp } from "./types";

// Routes
import { Routes as PriceRoutes } from "./routes";

// Pages
import PriceListSearchPage from "../PriceListSearchPage/PriceListSearchPage";
import PriceListDetailPage from "../PriceListDetailPage/PriceListDetailPage";


// eslint-disable-next-line @typescript-eslint/no-unused-vars
const PricesRouter: PriceRouterCmp = () => {
  return (
    <>
      <Routes>
        <Route
          path={PriceListSearchPage.route}
          element={<PriceListSearchPage />}
        />
        <Route
          path={PriceListDetailPage.route}
          element={<PriceListDetailPage />}
        />
      </Routes>
    </>
  );
};

PricesRouter.route = PriceRoutes.PriceRouter;

export default PricesRouter;
